"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _css = require("@emotion/css");
var _visuallyHidden = _interopRequireDefault(require("./../_styles/visually-hidden"));
var _token = require("./../_utils/token");
var indeterminateLinearAnimation = (0, _css.keyframes)({
  from: {
    transform: "scaleX(0.25) translateX(-100%)"
  },
  to: {
    transform: "scaleX(1) translateX(150%)"
  }
});
var indeterminateLinearAnimationRtl = (0, _css.keyframes)({
  from: {
    transform: "scaleX(1) translateX(150%)"
  },
  to: {
    transform: "scaleX(0.25) translateX(-100%)"
  }
});
var linearWrapperStyle = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var size = _ref.size;
  return (0, _css.css)({
    display: "flex",
    borderRadius: t("borderRadius"),
    width: "100%",
    minWidth: 100,
    height: t("trackLinear", [size, "height"]),
    backgroundColor: t("trackBackgroundColor"),
    border: "".concat(t("borderWidth"), "px solid ").concat(t("borderColor")),
    position: "relative",
    overflow: "hidden",
    // HACK: This allows `overflow: hidden` + `position: relative` to work
    // as intended in Safari desktop
    zIndex: 0
  });
}, ["size"]);
var linearIndeterminateStyle = function linearIndeterminateStyle(t) {
  return (0, _defineProperty2["default"])({
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    borderRadius: t("borderRadius"),
    transformOrigin: "top left",
    animation: "".concat(indeterminateLinearAnimation, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  }, "[dir=\"rtl\"] &", {
    animation: "".concat(indeterminateLinearAnimationRtl, " ").concat(t("indicatorMotionIndeterminateDuration"), " ").concat(t("indicatorMotionIndeterminateFunction"), " infinite")
  });
};
var linearIndicatorStyle = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var determinate = _ref3.determinate,
    _ref3$percentage = _ref3.percentage,
    percentage = _ref3$percentage === void 0 ? 0 : _ref3$percentage;
  return (0, _css.css)({
    width: "".concat(percentage, "%"),
    height: "100%",
    backgroundColor: t("indicatorBackgroundColor"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  }, !determinate ? linearIndeterminateStyle(t) : undefined);
}, ["determinate", "percentage"]);
var linearPercentageStyle = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var percentage = _ref4.percentage;
  return (0, _css.css)({
    width: "".concat(percentage, "%"),
    textAlign: "end",
    marginTop: t("percentageSpacing"),
    transition: t.transitionCss("indicatorMotionDeterminate", "width")
  });
}, ["percentage"]);
var labelStyles = (0, _css.css)(_visuallyHidden["default"]);

/* eslint-disable react/prop-types */
var LinearLoader = function LinearLoader(_ref5) {
  var t = _ref5.t,
    percentage = _ref5.percentage,
    showPercentageText = _ref5.showPercentageText,
    size = _ref5.size,
    label = _ref5.label,
    determinate = _ref5.determinate,
    children = _ref5.children;
  var useAriaLabel = !(determinate && showPercentageText);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-label": useAriaLabel ? label : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearWrapperStyle(t, {
      size: size
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: linearIndicatorStyle(t, {
      determinate: determinate,
      percentage: percentage
    })
  })), !useAriaLabel ? /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    "aria-atomic": "true",
    className: linearPercentageStyle(t, {
      percentage: percentage
    })
  }, children, /*#__PURE__*/_react["default"].createElement("span", {
    className: labelStyles
  }, label)) : null);
};
/* eslint-enable react/prop-types */
var _default = LinearLoader;
exports["default"] = _default;